import React, { memo } from 'react';
import { Button, Dropdown } from 'antd';
import { AssetItemDto } from '@api/Api';
import { ReactComponent as FolderSvg } from '@assets/icons/folder.svg';
import { ReactComponent as PrivateFolderSvg } from '@assets/icons/folder-private.svg';
import { ReactComponent as DownloadInvoiceSvg } from '@assets/icons/download-invoice.svg';
import { ReactComponent as ActionSvg } from '@assets/icons/action.svg';
import { FolderWithItems } from '@pages/Campaigns/CampaignReview/utils';
import { downloadAll } from '@helpers/download';

import TilesViewItem from './TilesViewItem';

import './TilesView.less';

type TilesViewProps = {
  onSelectFolder: (folderId: string) => void;
  onOpenAsset: (asset: AssetItemDto) => void;
  folders: FolderWithItems[];
  assetsList: AssetItemDto[];
  isOpenFolder: boolean;
};
export default memo(function TilesView({
  onSelectFolder,
  onOpenAsset,
  folders,
  assetsList,
  isOpenFolder
}: TilesViewProps) {
  return (
    <div className="campaign-review-tiles-view">
      {!!folders?.length && !isOpenFolder && (
        <div className="campaign-review-tiles-view-folders">
          <div className="campaign-review-tiles-view-label">Folders</div>
          <div className="campaign-review-tiles-view-folders-list">
            {folders.map((folder) => {
              const assetsDownloadUrls = folder.items
                .filter((asset) => !!asset.asset?.permissions.download)
                .map((asset) => asset.asset?.versions[0].sourceUrl);
              return (
                <div
                  className="campaign-review-tiles-view-folder"
                  key={folder.id}
                  onClick={() => onSelectFolder(folder.id)}
                >
                  {folder.isPrivate ? <PrivateFolderSvg /> : <FolderSvg />}
                  <div className="campaign-review-tiles-view-folder-name">
                    {folder.name}
                  </div>
                  <Dropdown
                    menu={{
                      onClick: ({ domEvent }) => domEvent.stopPropagation(),
                      items: [
                        {
                          key: 'download',
                          icon: (
                            <DownloadInvoiceSvg className="b-opacity-icon" />
                          ),
                          disabled: !assetsDownloadUrls?.length,
                          label: 'Download',
                          onClick: () => {
                            if (!assetsDownloadUrls?.length) return;
                            downloadAll(
                              assetsDownloadUrls,
                              `${folder.name}.zip`
                            );
                          }
                        }
                      ]
                    }}
                    overlayClassName="asset_links_overlay"
                    placement="bottomLeft"
                    trigger={['click']}
                  >
                    <Button
                      onClick={(e) => e.stopPropagation()}
                      type="text"
                      size="small"
                      style={{
                        padding: 0,
                        width: 24,
                        height: 24,
                        marginLeft: 'auto'
                      }}
                    >
                      <ActionSvg style={{ marginRight: 0 }} />
                    </Button>
                  </Dropdown>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {!!assetsList?.length && (
        <div className="campaign-review-tiles-view-assets">
          <div className="campaign-review-tiles-view-label">Assets</div>
          <div className="campaign-review-tiles-view-assets-list">
            {assetsList.map((item) => {
              return (
                <TilesViewItem
                  key={item.id}
                  asset={item}
                  onOpenAsset={onOpenAsset}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
});
